import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";

interface StreamingListPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class StreamingListPage extends Component<StreamingListPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.streaming(this.props),
                    list: {}
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}